import {IController} from "angular";
import * as angular from "angular";
import {LocationType} from "../../../commons/types/location.type";

export class FulfillmentStepsTableRowNewComponent implements IController{
  step: any;
  isSelected: boolean;
  onToggleSelect:Function;

  public locationTypes: typeof LocationType = LocationType;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsTableRowNew', {
    bindings: {
      step: '<',
      isSelected: '<?',
      onToggleSelect: '&'
    },
    template: require('./fulfillment-steps-table-row-new.html').default,
    controller: FulfillmentStepsTableRowNewComponent
  });
